import AddPositioningDeviceFittingsModal from './add-positioning-device-fittings-modal.vue'
export default AddPositioningDeviceFittingsModal
